import { PriceBookEntryVm } from '@/types';

export type Props = {
  classes?: Partial<{
    container: string;
    image: string;
    imageLabel: string;
    imageWrapper: string;
    title: string;
    wrapper: string;
  }>;
  shingleColor: PriceBookEntryVm;
  selectColor: (color: PriceBookEntryVm) => void;
  isActive: boolean;
};

export const SHINGLE_COLORS: { [name: string]: string } = {
  Birchwood: '/assets/images/shingle_colors/birchwood.svg',
  'Pewter Gray': '/assets/images/shingle_colors/pewter_gray.svg',
  'Birchwood Plus': '/assets/images/shingle_colors/birchwood.svg',
  'Pewter Gray Plus': '/assets/images/shingle_colors/pewter_gray.svg',
  Charcoal: '/assets/images/shingle_colors/charcoal.svg',
  Barkwood: '/assets/images/shingle_colors/barkwood.svg',
  'Biscayne Blue': '/assets/images/shingle_colors/biscayne_blue.svg',
  Driftwood: '/assets/images/shingle_colors/driftwood.svg',
  'Fox Hollow Gray': '/assets/images/shingle_colors/fox_hollow_gray.svg',
  Hickory: '/assets/images/shingle_colors/hickory.svg',
  'Hunter Green': '/assets/images/shingle_colors/hunter_green.svg',
  'Mission Brown': '/assets/images/shingle_colors/mission_brown.svg',
  'Oyster Gray': '/assets/images/shingle_colors/oyster_gray.svg',
  'Patriot Red': '/assets/images/shingle_colors/patriot_red.svg',
  'Weathered Wood': '/assets/images/shingle_colors/weathered_wood.svg',
  'Weathered Wood Plus': '/assets/images/shingle_colors/weathered_wood.svg',
  Shakewood: '/assets/images/shingle_colors/shakewood.svg',
  Slate: '/assets/images/shingle_colors/slate.svg',
  'Williamsburg Slate': '/assets/images/shingle_colors/williamsburg_slate.svg',
};
